import { __spreadArrays } from "tslib";
import { debug } from 'shared/utils';
/**
 * Determine which Layout is the closest match for the given width and height.
 */
export var layoutMatcher = function (width, height, layouts) {
    if (layouts.length < 1) {
        throw new Error('At least one Layout is required.');
    }
    var sortedFuzzyMatches = fuzzyMatchLayouts(width, height, layouts);
    var match = sortedFuzzyMatches[0].layout;
    debug("Matched Layout " + match.name);
    return match;
};
/**
 * Determine which size is the closest match for the given width and height.
 */
export var sizeMatcher = function (width, height, layouts) {
    var _a, _b, _c;
    if (layouts.length < 1) {
        throw new Error('At least one Layout is required.');
    }
    var pxSizes = layouts.reduce(function (carrier, l) { return __spreadArrays(carrier, l.pxSizes); }, []);
    var bestMatch = closestPxSize(width, height, pxSizes);
    debug("Matched size: " + JSON.stringify((_b = (_a = bestMatch) === null || _a === void 0 ? void 0 : _a.pxSize, (_b !== null && _b !== void 0 ? _b : {}))));
    return (_c = bestMatch) === null || _c === void 0 ? void 0 : _c.pxSize;
};
/**
 * For the given Layouts, analyze their PxSizes and report
 * the distance from the closest match to the given dimensions.
 */
var fuzzyMatchLayouts = function (width, height, layouts) {
    var result = layouts
        .map(fuzzyMatchLayout(width, height))
        .sort(function (a, b) { return a.distance - b.distance; });
    return result;
};
/**
 * Analyze a Layout's PxSizes, and find the distance
 * from the closest match to the given width and hight.
 */
var fuzzyMatchLayout = function (width, height) { return function (layout) {
    var distance = closestDistanceFromPxSizes(width, height, layout.pxSizes);
    return {
        distance: distance,
        layout: layout,
    };
}; };
/**
 * Given an array of PxSizes, find the closest distance
 * between them to the given height and width.
 */
export var closestDistanceFromPxSizes = function (width, height, pxSizes) {
    var bestMatch = closestPxSize(width, height, pxSizes);
    return bestMatch ? bestMatch.distance : Infinity;
};
/**
 * Find the PxSize that is closest to the given width and height.
 */
export var closestPxSize = function (width, height, pxSizes) {
    return pxSizes.length === 0
        ? undefined
        : pxSizes
            .map(distanceToPxSize(width, height))
            .sort(function (a, b) { return a.distance - b.distance; })[0];
};
/**
 * Determine a distance from the given dimensions to the
 * provided PxSize. The distance is based on the ratios,
 * and a smaller distance represents a closer match.
 */
var distanceToPxSize = function (width, height) { return function (pxSize) {
    var goalRatio = width / height;
    var thisRatio = pxSize.w / pxSize.h;
    var ratioDistance = Math.abs(goalRatio - thisRatio);
    var widthDistance = Math.abs(width - pxSize.w) / width;
    var distance = ratioDistance + widthDistance;
    return { pxSize: pxSize, distance: distance };
}; };
